<script>
import AppointmentStore from "../../mixins/appointment-store";

export default {
    name: "ActiveVehicle",

    mixins: [AppointmentStore],

    computed: {
        vehicleData() {
            return this.appointmentStore.vehicleData
        }
    },

    methods: {
        formatApkDate(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
        },

        formatConstructionYear(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            return date.getFullYear();
        },
    }
}
</script>

<template>
    <div class="vue-active-vehicle">
        <h3>{{ vehicleData.merk }} {{ vehicleData.handelsbenaming }}</h3>

        <ul>
            <li>
                APK Vervalt

                <span class="tag mt-2"> {{ formatApkDate(vehicleData.vervaldatum_apk_dt) }}</span>
            </li>
            <li>
                Bouwjaar

                <span class="tag mt-2">{{ formatConstructionYear(vehicleData.datum_eerste_toelating_dt) }}</span>
            </li>
        </ul>
    </div>
</template>